import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { startLinkProps } from '../data';

export default function NotFound() {
  return (
    <section className="section page-document not-found">
      <Seo
        title="Page not found | RIME | Bookkeeping + Payroll"
        description="The page you’re looking for isn’t available. Return to Rime for bookkeeping and payroll services."
        path=""
        robots="noindex, nofollow"
      />
      <div className="container page-document-inner" data-reveal>
        <p className="eyebrow">Error 404</p>
        <h1 className="display-2">
          Page not <em>found.</em>
        </h1>
        <p className="lede">
          The page you’re looking for isn’t available. Head back home, or get in touch and we’ll
          help you find the right place to start.
        </p>
        <div className="page-actions">
          <Link className="btn btn-primary" to="/">
            Back to home
          </Link>
          <a className="btn btn-soft" {...startLinkProps}>
            Schedule a call
          </a>
        </div>
      </div>
    </section>
  );
}
